import { Link } from 'react-router-dom'
import { Instagram, Facebook, Twitter } from 'lucide-react'
import { BrandLogo } from '@/components/shared/BrandLogo'

// Perfis oficiais da marca. Enquanto estiverem vazios, os ícones não são
// renderizados — antes eles apontavam para `href="#"`, que recarregava a página.
const SOCIAL_LINKS: { icon: typeof Instagram; label: string; href: string }[] = [
  { icon: Instagram, label: 'Instagram', href: '' },
  { icon: Facebook, label: 'Facebook', href: '' },
  { icon: Twitter, label: 'X (Twitter)', href: '' },
]

export default function Footer() {
  return (
    <footer className="border-t bg-slate-900 text-slate-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <div className="mb-3">
              <BrandLogo onDark className="h-8" />
            </div>
            <p className="text-sm leading-relaxed text-slate-400">
              A plataforma que conecta alunos a instrutores de direção qualificados em todo o Brasil.
            </p>
            {SOCIAL_LINKS.some((s) => s.href) && (
              <div className="mt-4 flex gap-3">
                {SOCIAL_LINKS.filter((s) => s.href).map(({ icon: Icon, label, href }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="hover:text-white transition-colors"
                  >
                    <Icon className="h-5 w-5" />
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Para alunos */}
          <div>
            <h3 className="font-semibold text-white mb-3">Para alunos</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/instrutores" className="hover:text-white transition-colors">Encontrar instrutor</Link></li>
              <li><Link to="/como-funciona" className="hover:text-white transition-colors">Como funciona</Link></li>
              <li><Link to="/presentes" className="hover:text-white transition-colors">Vale-aula de presente</Link></li>
              <li><Link to="/cadastro" className="hover:text-white transition-colors">Criar conta</Link></li>
            </ul>
          </div>

          {/* Para instrutores */}
          <div>
            <h3 className="font-semibold text-white mb-3">Para instrutores</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/seja-instrutor" className="hover:text-white transition-colors">Seja um instrutor</Link></li>
              <li><Link to="/cadastro" className="hover:text-white transition-colors">Cadastrar-se</Link></li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h3 className="font-semibold text-white mb-3">Empresa</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/seguranca" className="hover:text-white transition-colors">Segurança</Link></li>
              <li><Link to="/privacidade" className="hover:text-white transition-colors">Política de privacidade</Link></li>
              <li><Link to="/termos" className="hover:text-white transition-colors">Termos de uso</Link></li>
              <li><Link to="/politica-cancelamento" className="hover:text-white transition-colors">Política de cancelamento</Link></li>
              <li><Link to="/ajuda" className="hover:text-white transition-colors">Ajuda</Link></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-slate-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} MeuDriver. Todos os direitos reservados.</p>
          <p>Feito com ❤️ no Brasil</p>
        </div>
      </div>
    </footer>
  )
}
